<template>
  <div class="coindetail">
    <XR-head titleText="交易明细" :rightShow="false"></XR-head>
    <div class="detail-traceAmt" v-if="!loaded">
        <span class="amt">{{streamDetailInfo.Operater+streamDetailInfo.TraceAmt.toFixed(2)}}</span>
    </div>
    <div class="row-list" v-if="!loaded">                      
      <div class="row-item">
          <p class="item-title">交易单号</p>
          <p class="item-value">{{streamDetailInfo.TraceNo}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">交易类型</p>
          <p class="item-value">{{streamDetailInfo.TraceTypeName}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">交易时间</p>
          <p class="item-value">{{streamDetailInfo.AddTimeName}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">备注</p>
          <p class="item-value">{{streamDetailInfo.Desc}}</p>
      </div>
    </div>
    <XR-toast  ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
        loaded:true,        
        streamDetailInfo :{
            AddTime:"",
            AddTimeName:'',
            Desc:"",
            Operater:"-",
            TraceNo:"",
            TraceNoName:'',
            TraceType:"",
            TraceTypeName:"",
            TraceAmt:0
        }
    };
  },
  mounted: function(){
    this.$refs.XRtoast.load()
    if(this.$route.query.traceNo){
        this.getDetailInfo()
    }
  },
  methods: {
    getDetailInfo: function() {
      var ths = this;   
      ths.$post(
        "/Salesman/PurchaseServer/GetPurchaseCoinStreamDetail",
        JSON.stringify({'traceNo': ths.$route.query.traceNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.$refs.XRtoast.hide()
          ths.streamDetailInfo = res.Data;
          ths.loaded= false
        }
      });
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
#app .coindetail{
    background: white;
}
.coindetail .detail-traceAmt {
    overflow:hidden;
    text-align:center;
    margin: 0 20px;
    border-bottom:1px solid #efefef;
    padding:35px 0 35px;
}
    .coindetail .detail-traceAmt .amt {
        font-size:30px;
    }
    .coindetail .detail-traceAmt .unit {
        font-size:12px;
        color:#aaa;
    }
.coindetail .row-list {
    margin: 0 20px;
    padding:30px 0;
}
   .coindetail  .row-list .row-item {
        padding:10px 0;
    }
      .coindetail   .row-list .row-item .item-title {
            color:#ccc;
            font-size:16px;
        }
       .coindetail  .row-list .row-item .item-value {
            font-size:12px;
            padding-top:2px;
            word-break: break-all;
        }
    .coindetail .row-list.last {
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/purchasecoindetail.vue